import { FindTargetBreakdownsData } from '../../services/modules/target/target.repository.types';

export const getExpandableDepths = (
  items: Pick<FindTargetBreakdownsData, 'id' | 'parentId' | 'depth'>[],
): Set<number> => {
  const parentIds = new Set(items.map((item) => item.parentId));

  return new Set(items.filter((item) => parentIds.has(item.id)).map((item) => item.depth));
};
